import { useQuery } from '@tanstack/react-query';

import { getRepairOrderExistsApi } from 'api/repairOrder';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';
import type { RooftopExistsI } from 'declarations/interfaces/rooftopExists';

export const useFetchTicketRoExists = (
  roofTopId: string,
  roNumber: string
): ReturnType<typeof useQuery<RooftopExistsI, ApiErrorI>> => {
  return useQuery<RooftopExistsI, ApiErrorI>(
    [RequestQueryKeysE.FetchRepairOrder, roofTopId, roNumber],
    async (): Promise<RooftopExistsI> => getRepairOrderExistsApi(roofTopId, roNumber),
    {
      enabled: !!roofTopId && !!roNumber,
    }
  );
};
